import axios from "axios";
import store from "@/store";
import {builderBaseUrl} from "@/main";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {queryBuilder, filters} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))

export default {
    namespaced: true,
    state: {
        projects: [],
        project: null,
        ...filtersCopy,
    },
    mutations: {
        setProjects(state, projects) {
            state.projects = projects;
        },
        setProject(state, project) {
            state.project = project;
        },
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        setProjects({commit, state}) {
            // convert filter items to query string
            const user_id = store.getters['User/getUserId']
            axios.get(`${builderBaseUrl}/projects/user/${user_id}`)
                .then((res) => {
                    let projects = res.data.data;
                    commit("setProjects", projects);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getProject({commit, state}, form) {
            // convert filter items to query string
            const user_id = store.getters['User/getUserId']
            commit("setProject", null);
            axios.get(`${builderBaseUrl}/project/${form.project_id}/user/${user_id}`)
                .then((res) => {
                    let project = res.data.data;
                    commit("setProject", project);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setProjectIcons({commit, state}, form) {
            // convert filter items to query string
            const user_id = store.getters['User/getUserId']
            axios.post(`${builderBaseUrl}/project/image/${state.project.id}/user/${user_id}`, form)
                .then((res) => {
                    toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getPersons({state, commit}, page = 1) {
            const query = queryBuilder(state.filters)
          return   axios.get(`${builderBaseUrl}/user?page=${page}&${query}`)
        },
        creatProject({commit, state}, form) {

            let req = axios.post(`${builderBaseUrl}/project/user/${form.user_id}`, form)



            return req
        },
    },
    getters: {
        getProjects: state => state.projects,
        getProject: state => state.project,
    },
}